<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<footer class="xrx-footer">
  <div class="content">
    <nav>
      <ul>
        <li>
          <a routerLink="/terms" target="_blank" xdaTranslate>SDE_TERMS1</a>
        </li>
        <li>
          <a [attr.href]="privacyUrl" target="_blank" xdaTranslate
            >SDE_PRIVACY</a
          >
        </li>
        @if (isSubUser) {
          <li>
            <a [attr.href]="secGuideUrl" target="_blank" xdaTranslate
              >SDE_SECURITY_GUIDE</a
            >
          </li>
        }
        <li>
          <a [attr.href]="softwareDisclosureUrl" target="_blank" xdaTranslate
            >SDE_SOFTWARE_DISCLOSURE</a
          >
        </li>
        @if (isSubUser) {
          <li>
            <a [attr.href]="documentationUrl" target="_blank" xdaTranslate
              >SDE_DOCUMENTATION</a
            >
          </li>
        }
        @if (isSubUser) {
          <li>
            <a [attr.href]="supportURL" target="_blank" xdaTranslate
              >SDE_SUPPORT</a
            >
          </li>
        }
      </ul>
    </nav>
    <div
      class="xerox-copyright"
      [xdaTranslate]="'SDE_FMTSTRFMTSTR_XEROX_CORPORATION2'"
      [formatValues]="'2026'"></div>
  </div>
</footer>
